module.exports = __webpack_public_path__ + "static/media/masrt-work-banner-video.61c00942.jpg";